import { Component } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Angular2TokenService } from 'angular2-token';
import { Globals } from './globals';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  loginText: string;
  pwdText: string;

  constructor(private _tokenService: Angular2TokenService, private httpClient: HttpClient, private globals: Globals) {
    this._tokenService.init();
  }

  login() {
    if (this.loginText === 'mirkku' && this.pwdText === 'siirisaara1') {
      this.globals.personLogged = true;
    }
  }

  logout() {
    this.globals.personLogged = false;
  }
}



// WEBPACK FOOTER //
// C:/DEV/saaristonsiirin/src/app/app.component.ts